import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { getSummaryTypesOrderByProductType } from './getSummaryTypesOrderByProductType';
import { modifySummaries } from './modifySummaries';

type TSummaryItem = NonNullable<MPLPreApprovalOffer['summaries']>[number];

export const modifyPreApprovalOfferSummaries = (
  summaries: MPLPreApprovalOffer['summaries'],
  productType: MPLPreApprovalOffer['productType'],
) => {
  const summariesOrder = getSummaryTypesOrderByProductType(productType);

  return modifySummaries(
    summariesOrder.reduce<TSummaryItem[]>((acc, summaryType) => {
      const summary = summaries?.find((item) => item.label === summaryType);

      if (summary) {
        acc.push(summary);
      }

      return acc;
    }, []),
  );
};
